import { Row, Col, Container } from "react-bootstrap";
import JSONPretty from "../../jsonPrettyOverride/JSONPretty";
import { OrgIdContext } from "../../../store/orgId_context";
import { tx } from "../../../lib/ddd/ddd";
import classes from "./IntegrationComponentsFull.module.scss"
import { Skeleton } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import ReceiptIcon from '@mui/icons-material/Receipt';
import { CopyBlock, a11yDark, codepen, dracula, monokaiSublime } from 'react-code-blocks';
import textfile from "../../../assets/javascriptInvoice.txt";

const JSFull = ({objectResponse, complexity="Normal"}) => {
    const [csharpInvoice, setCSharpInvoice] = useState();
    const {  integrationDevice } = useContext(OrgIdContext);

    
    useEffect(() => {
        if(!integrationDevice)return;

        fetch(textfile)
        .then((response) => response.text())
        .then((textContent) => {
            let csharp = textContent
                        .replace(/<integraion-key>/gi, integrationDevice)
                        .replace(/<location-origin>/gi, window.location.hostname)
                        
            setCSharpInvoice(csharp);
        });
    }, [integrationDevice]);

    return(
        <>
        <div style={{marginBottom:"1rem"}}>
            Full example of creating a new Invoice. First we call the <u>{tx("DDDI_GetNew")}</u> API to get an initialized blank invoice.
            Parse it into our Invoice class object. Enter minimal amount of data for invoice to pass all checks and save it by calling
            the <u>{tx("DDDI_Save")}</u> API.
        </div>
        <div className={`${classes["integration-full-codeblock"]}`} style={{maxHeight:"none"}}>
            <CopyBlock
            text={csharpInvoice}
            language={"html"}
            showLineNumbers={true}
            wrapLines
            theme={a11yDark}
            />
        </div>
        </>
    )
}

export default JSFull;